// One form control rendered from a field definition in content/forms.js.
export const Field = ({ field, value, error, onChange, idPrefix }) => {
  const id = `${idPrefix}-${field.name}`;
  const common = {
    id,
    name: field.name,
    required: field.required,
    "aria-invalid": error ? "true" : undefined,
    "aria-describedby": error ? `${id}-error` : undefined,
    "data-testid": `${idPrefix}-${field.name}-input`,
  };
  const span = field.span === "full" || field.type === "textarea" ? "sm:col-span-2" : "";
  const errorEl = error && (
    <p id={`${id}-error`} className="mt-1.5 text-[13px] text-[#b4402f] dark:text-[#f08a76]" data-testid={`${id}-error`}>
      {error}
    </p>
  );

  if (field.type === "checkbox") {
    return (
      <div className={span}>
        <label htmlFor={id} className="flex cursor-pointer items-start gap-3 text-[14px] leading-relaxed text-muted">
          <input
            {...common}
            type="checkbox"
            checked={!!value}
            onChange={(e) => onChange(field.name, e.target.checked)}
            className="mt-1 h-4 w-4 shrink-0 accent-[rgb(var(--accent))]"
          />
          <span>{field.label}</span>
        </label>
        {errorEl}
      </div>
    );
  }

  const label = (
    <label htmlFor={id} className="field-label">
      {field.label}
      {field.required && <span className="text-accent"> *</span>}
    </label>
  );

  let control;
  if (field.type === "select") {
    control = (
      <select {...common} className="field-input" value={value || ""} onChange={(e) => onChange(field.name, e.target.value)}>
        <option value="">Select…</option>
        {field.options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    );
  } else if (field.type === "textarea") {
    control = (
      <textarea {...common} rows={5} className="field-input resize-y" placeholder={field.placeholder} value={value || ""} onChange={(e) => onChange(field.name, e.target.value)} data-lenis-prevent />
    );
  } else {
    control = (
      <input
        {...common}
        type={field.type}
        className="field-input"
        placeholder={field.placeholder}
        autoComplete={field.autoComplete}
        value={value || ""}
        onChange={(e) => onChange(field.name, e.target.value)}
      />
    );
  }

  return (
    <div className={span}>
      {label}
      {control}
      {errorEl}
    </div>
  );
};
